<wiz-vgroup width="100%" height="100%" padding="5px" class="section-container">
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="'$.new-tab.adding-new-template.$'" class="smallTitleLabel" width="100%"></wiz-label>
    <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
  </wiz-hgroup>
  <wiz-vgroup height="100%" wizValidationContainer  width="100%" padding=" 0 15px">
    <wiz-text-input
      width="100%"
      #tiCode
      wizLabel="$.common.code.$"
      wizDisabled="true"
    ></wiz-text-input>

    <wiz-translation-basic
      #tiLabel
      wizValidator
      [maxTranslation]="6"
      [wizLabel]="'$.common.label.$'"
      [wizPlaceholder]="'$.common.define.$'"
      [wizMandatory]="true"
      [wizMaxChars]="50"
      width="100%"
    ></wiz-translation-basic>

    <wiz-translation-basic
      #tiDescription
      [wizMaxChars]="255"
      [wizTranslationMode]="'textarea'"
      [maxTranslation]="6"
      [wizLabel]="'$.common.description.$'"
      width="100%"
      height="80px"
    ></wiz-translation-basic>

    <wiz-hgroup >
      <!-- couleur du tab -->
      <wiz-vgroup width="110px">
        <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
        <wiz-hgroup>
          <span
            #blockBack
            [style.backgroundColor]="backgroundColor"
            width="20px"
            height="20px"
            (click)="showColorPicker($event)"
            style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
          ></span>
          <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
        </wiz-hgroup>
      </wiz-vgroup>
      
      <!-- icone -->
      <wiz-vgroup gap="0" height="100%">
        <wiz-label [wizLabel]="'$.freedata.image.$'" class="componentLabel"></wiz-label>
        <wiz-image
          #uploadImg
          tabindex="0"
          height="50px"
          class="img-picker"
          [blobid]="imgBlobid"
          [sourceObservable]="imgSrcObs"
          [useHandCursor]="true"
          (click)="clickForUpload()"
          (keydown)="keydownForUpload($event)"
        ></wiz-image>
      </wiz-vgroup>
      <wiz-icon [visible]="hasImage()" style="cursor: pointer; font-size: 20px" (click)="clearImage()"
      >delete</wiz-icon>

    </wiz-hgroup>


  </wiz-vgroup>
  <wiz-hgroup width="100%" horizontalAlign="flex-end">
    <wiz-button [wizLabel]="'$.common.validate.$'" (wizClick)="validate()" [wizDisabled]="!isValidable"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
